import { translateError } from 'utils/validation';

import { useLang } from 'locale';
import { cn } from 'styles';

interface FieldErrorProps {
  className?: string;
  error: unknown;
}

export function FieldError({ error, className }: FieldErrorProps) {
  const { t } = useLang();

  const actualError = typeof error === 'object' ? translateError(error ?? {}, t) : error;

  if (typeof actualError !== 'string') return null;

  return (
    <span
      className={cn(
        '-mt-1 pl-0.5 text-sm text-destructive animate-in fade-in-0 slide-in-from-top-2',
        className,
      )}
    >
      {actualError}
    </span>
  );
}
